import React from 'react';

const JERSEYS = [
  { id: 'jersey1', label: '1' },
  { id: 'jersey2', label: '2' },
  { id: 'jersey3', label: '3' },
];

export default function JerseySelector({ selectedJersey, onSelectJersey }) {
  return (
    <div className="pcg-jersey-wrap">
      <p className="pcg-jersey-label">Jersey template</p>
      <div className="pcg-jersey-grid">
        {JERSEYS.map(({ id, label }) => {
          const selected = selectedJersey === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => onSelectJersey(id)}
              aria-pressed={selected}
              title={`Template ${label}`}
              className={`pcg-jersey-btn${selected ? ' pcg-jersey-btn-selected' : ''}`}
            >
              <img
                src={`/templates/${id}.png`}
                alt=""
                className="pcg-jersey-thumb"
                draggable={false}
              />
              <span className="pcg-jersey-num">{label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
